import { PropertyGridEditorCollection } from 'survey-creator-react';
import { Serializer } from 'survey-core';

PropertyGridEditorCollection.register({
  fit: (prop) => prop.type === 'customPresetDropdown',
  getJSON: (obj, prop) => {
    return {
      type: 'dropdown',
      choices: prop.getChoices(obj),
      allowClear: true,
    };
  },
  onAfterRenderQuestion: (obj, prop, evtOptions) => {
    const selectElement = evtOptions.htmlElement.querySelector('select');
    if (!selectElement) return;

    const choices = prop.getChoices(obj);
    selectElement.innerHTML = '';
    choices.forEach((choice) => {
      const option = document.createElement('option');
      option.value = choice.value;
      option.text = choice.text;
      selectElement.appendChild(option);
    });

    const currentValue = obj.getPropertyValue('preset') || '';
    selectElement.value = currentValue;

    selectElement.onchange = (e: any) => {
      const newValue = (e.target as HTMLSelectElement).value;
      obj.setPropertyValue('preset', newValue === '' ? '' : newValue);
    };
  },
});

Serializer.addProperty('customPresetDropdown', {
  name: 'preset',
  type: 'string',
  category: 'general',
});
